import './Pipeline.scss';
import Component from './Pipeline.js';
export default Component;
